export const getLocalUTCTime = () => {
  const unixTime = Math.floor(Date.now() / 1000);

  return String(unixTime)
};

const KEY = 3;

export const encrypt = (text, key = KEY) => {
  let result = '';

  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(text.charCodeAt(i) + key);
  }

  return btoa(result); // base64 encode
}

export const decrypt = (encodedText, key = KEY) => {
  const decoded = atob(encodedText); // base64 decode
  let result = '';
  for (let i = 0; i < decoded.length; i++) {
    result += String.fromCharCode(decoded.charCodeAt(i) - key);
  }
  return result;
}

export const differenceInSeconds = (date1) => {
  
  const unixTime1 = Math.floor(Date.now() / 1000);
  const diffInSeconds = unixTime1 - date1;

  return Math.floor(diffInSeconds);
}

